import Box from '@mui/material/Box';
import Skeleton, { SkeletonProps } from '@mui/material/Skeleton';

interface PaymentElementSkeletonProps {
  textSkeleton?: SkeletonProps;
  inputSkeleton?: SkeletonProps;
}

export const PaymentElementSkeleton = ({
  textSkeleton,
  inputSkeleton,
}: PaymentElementSkeletonProps) => {
  return (
    <Box width={'100%'}>
      <Skeleton variant="rounded" width={80} height={13} {...textSkeleton} />
      <Skeleton
        variant="rounded"
        width={'100%'}
        sx={{ marginTop: '4px' }}
        height={45}
        {...inputSkeleton}
      />
    </Box>
  );
};
